import { useState } from "react";
import { XIcon, ChevronDownIcon } from "@heroicons/react/outline";

const TagMultiSelect = ({ label, options, selected, setSelected }) => {
  const [open, setOpen] = useState(false);

  const toggleSelect = (item) => {
    if (selected.find((s) => s.id === item.id)) {
      setSelected(selected.filter((s) => s.id !== item.id));
    } else {
      setSelected([...selected, item]);
    }
  };

  const removeItem = (id) => {
    setSelected(selected.filter((s) => s.id !== id));
  };

  return (
    <div className="space-y-2">
      <label className="text-sm text-slate-300">{label}</label>

      <div className="relative">
        <div
          onClick={() => setOpen(!open)}
          className="min-h-[44px] flex flex-wrap gap-2 items-center px-3 py-2 bg-[#131C31] border border-white/10 rounded-lg cursor-pointer"
        >
          {selected.map((item) => (
            <div
              key={item.id}
              className="flex items-center gap-1 bg-slate-700 text-white px-3 py-1 rounded-full text-sm"
            >
              {item.name}
              <XIcon
                className="w-3 h-3 cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation();
                  removeItem(item.id);
                }}
              />
            </div>
          ))}

          <ChevronDownIcon className="w-4 h-4 ml-auto text-slate-400" />
        </div>

        {open && (
          <div className="absolute w-full mt-2 bg-slate-900 border border-white/10 rounded-lg shadow-lg max-h-60 overflow-y-auto z-50">
            {options.map((item) => (
              <div
                key={item.id}
                onClick={() => toggleSelect(item)}
                className="px-4 py-2 text-sm text-slate-300 hover:bg-slate-800 cursor-pointer"
              >
                {item.name}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default TagMultiSelect;